module.exports = __webpack_public_path__ + "static/img/theme_1.0e4b9db0.png";